<section class="parent container-fluid px-2 px-md-6 px-lg-8">
    <div class="parent__container px-3 py-2">
        <div class="parent__container__top d-flex flex-column">
            <h2 class="parent__container__top__title pt-1 mb-2">
                {{
                    'fe_details_step5_reservation_parent_top_title' | translate
                }}
            </h2>
        </div>
        <div class="parent__container__bottom row">
            <div class="parent__container__bottom__first col-12 col-lg-8">
                <fe-reservation-details></fe-reservation-details>
                <div class="protection-notice" *ngIf="isLite">
                    <img
                        class="protection-notice__icon"
                        [src]="'images/whitout_extras.svg' | cdn"
                        alt=""
                    />
                    <div class="protection-notice__body">
                        <p class="protection-notice__title">
                            {{
                                'fe_details_step5_protection_notice_title'
                                    | translate
                            }}
                        </p>
                        <p class="protection-notice__text">
                            {{
                                'fe_details_step5_protection_notice_text'
                                    | translate
                            }}
                        </p>
                    </div>
                </div>
                <fe-rental-requirements
                    class="mt-4"
                ></fe-rental-requirements>
            </div>
            <div class="parent__container__bottom__second col-12 col-lg-4">
                <div
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.currency !== 'MXN'
                    "
                    class="mb-2"
                >
                    <fe-cancel-reservation></fe-cancel-reservation>
                </div>
                <div
                    [ngClass]="{
                        'mb-4':
                            reservationDetails?.data?.reservationDetails
                                ?.currency === 'MXN',
                        'mb-2':
                            reservationDetails?.data?.reservationDetails
                                ?.currency !== 'MXN'
                    }"
                >
                    <fe-warranty [isLite]="isLite"></fe-warranty>
                </div>
                <div
                    [ngClass]="{
                        'mb-4':
                            reservationDetails?.data?.reservationDetails
                                ?.currency === 'MXN',
                        'mb-2':
                            reservationDetails?.data?.reservationDetails
                                ?.currency !== 'MXN'
                    }"
                >
                    <fe-tips></fe-tips>
                </div>
            </div>
        </div>
        <div class="parent__container__delivery-cancel row mb-4">
            <div class="col-12 col-md-8">
                <fe-delivery-status
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.currency === 'MXN'
                    "
                ></fe-delivery-status>
            </div>
            <div class="col-12 col-md-4">
                <fe-cancel-reservation
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.currency === 'MXN'
                    "
                ></fe-cancel-reservation>
            </div>
        </div>
    </div>
</section>
